import React, { useEffect, useState } from 'react';
import API from '../../services/api';
import './Analytics.css';

export const UPDATE_CATEGORY_LABEL = { update: 'Update', feature: 'New feature', maintenance: 'Maintenance', notice: 'Notice' };
const fmt = (d) => new Date(d).toLocaleDateString('en-IN', { day: '2-digit', month: 'short', year: 'numeric' });

// What the PLATFORM (Zaptude / Levrotec) tells this college's admins: releases, maintenance windows, notices.
// Read-only — students never see these, and they are separate from the announcements an admin sends to students.
export default function PlatformUpdates() {
  const [items, setItems] = useState(null);
  const [err, setErr] = useState('');

  const load = () => {
    setErr(''); setItems(null);
    API.get('/platform-updates/mine')
      .then(res => setItems(res.data || []))
      .catch(e => setErr(e.response?.data?.message || 'We could not load platform updates. Please try again.'));
  };
  useEffect(load, []);

  return (
    <div className="axh-page">
      <div className="axh-topbar">
        <div><h1>Platform Updates</h1><p>News from the Zaptude team — new features, maintenance windows and notices.</p></div>
      </div>

      {err && <div className="axh-error" role="alert">{err} <button type="button" className="axh-btn" onClick={load}>Retry</button></div>}
      {!err && items === null && <div className="axh-loading"><div className="axh-spinner" />Loading updates…</div>}
      {items && items.length === 0 && <div className="axh-card"><div className="axh-empty">You're all caught up — there are no platform updates right now.</div></div>}
      {items && items.length > 0 && (
        <div className="axh-grid-2">
          {items.map(u => (
            <div className="axh-card" key={u.id}>
              <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 8 }}>
                <span className="axh-pill" style={{ background: 'var(--z-info-tint)', color: 'var(--z-violet)' }}>{UPDATE_CATEGORY_LABEL[u.category] || u.category}</span>
                {u.pinned && <span className="axh-badge" style={{ background: 'var(--z-warning-tint)', color: 'var(--z-warning)' }}>Pinned</span>}
              </div>
              <h3 style={{ marginBottom: 6 }}>{u.title}</h3>
              <p style={{ fontSize: '0.86rem', color: 'var(--z-ink-2)', whiteSpace: 'pre-wrap', marginBottom: 10 }}>{u.body}</p>
              <p style={{ fontSize: '0.74rem', color: 'var(--z-muted-2)' }}>{fmt(u.publish_at)}{u.expires_at ? ` · until ${fmt(u.expires_at)}` : ''}</p>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
